<template>
  <el-dialog  :title="title" :visible.sync="innerVisible">
    <slot name="content"></slot>
    <slot name="footer"></slot>
  </el-dialog>
</template>
<script>
import { Dialog } from 'element-ui'
export default {
  name:'dialogBox',
  props:{
    title:{
      type: String,
      default:''
    },
    visible:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      
    }
  },
  methods:{

  },
  computed:{
    innerVisible:{
      get(v){
        return this.visible;
      },
      set(val){
        this.$emit('update:visible', val)
      }
    }
  },
  components:{
    elDialog: Dialog
  }
}
</script>
<style scoped>

</style>
<style>
.el-dialog{
  min-width: 500px;
}
</style>


// WEBPACK FOOTER //
// src/components/dialogBox.vue